export default 

class Step {

    constructor (id='', title='', sequence='', need_approval='', visible='', color='panel-primary') {
        this.id = id;
        this.title = title;
        this.sequence = sequence;
        this.need_approval = need_approval;
        this.visible = visible;
        this.color = color;
    }

}